// src/components/Header/Header.tsx
import React from 'react';
import styles from './Services.module.css';
import InformationCard from './InformationCard';
import { useTranslation } from 'react-i18next';
import carottage from '../../assets/images/carottage.jpg';
import sciage from '../../assets/images/sciage.jpeg';
import demolition from '../../assets/images/demolition.jpg';
const Services: React.FC = () => {
const { t,i18n } = useTranslation();
  return (
    <div className={styles.infoSection} id="services">

      <div >
        <h3 className={styles.infoTitle}>
          <span>{t('ourServices')}</span>
        </h3>
        <p className={`${styles.infoDescription} ${
    i18n.language === 'ar' ? styles.arabic : ''
  }`}>
          {t('carottageDescription')}
        </p>
      </div>
      <div className={styles.infoCardsContent}>
        <InformationCard
          title={t('carottage')}
          description={t('carottageDescription2')}
          image={carottage}
        />
        <InformationCard
          title= {t('sciage')}
          description={t('sciageDescription')}
          image={sciage}
        />

        <InformationCard
          title={t('demolition')}
          description={t('demolitionDescription')}
          status={t('comingSoon')}
          image={demolition}
        />
      </div>

    </div>
  );
}

export default Services;
